import { render, staticRenderFns } from "./PriceListBrowse.vue?vue&type=template&id=66c1211a&scoped=true"
import script from "./PriceListBrowse.vue?vue&type=script&lang=ts"
export * from "./PriceListBrowse.vue?vue&type=script&lang=ts"
import style0 from "./PriceListBrowse.vue?vue&type=style&index=0&id=66c1211a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66c1211a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('66c1211a')) {
      api.createRecord('66c1211a', component.options)
    } else {
      api.reload('66c1211a', component.options)
    }
    module.hot.accept("./PriceListBrowse.vue?vue&type=template&id=66c1211a&scoped=true", function () {
      api.rerender('66c1211a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/price-lists/PriceListBrowse.vue"
export default component.exports